export default {"src":"/_next/static/media/gradient-2.f73dd4c6.svg","height":451,"width":1162,"blurWidth":0,"blurHeight":0};